import DealEditBuyer from './DealEditBuyer'
export default DealEditBuyer
